import React, { useState } from 'react';
import axios from "axios";
import { toast } from 'react-toastify';

function InquiryForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    vehicleNumber: '',
    rcFile: null,
    vendorPhoto:  null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);  // Track submission state

  // Handle input changes for text fields
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle file uploads
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : null,
    });
  };

  // Validate the file type (PDF, PNG, JPG, JPEG, WebP)
  const validateFileType = (file: File | null, accept: string[]) => {
    if (file) {
      const fileType = file.type.split('/')[1].toLowerCase();
      return accept.includes(fileType);
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
   

    setIsSubmitting(true);  // Disable submit button during submission
    
    const data = new FormData();
    data.append("name", formData.name);
    data.append("phone", formData.phone);
    data.append("vehicleNumber", formData.vehicleNumber);

    if (formData.rcFile) {
      data.append("rcFile", formData.rcFile);
    }

    if (formData.vendorPhoto) {
      data.append("vendorPhoto", formData.vendorPhoto);
    }

    try {
      const response = await axios.post("https://qbus-admin-68c80d91deba.herokuapp.com/api/v1/Enquiry", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.status === 201) {
        toast.success("Successfully submitted your enquiry.");
        setFormData({
          name: '',
          phone: '',
          vehicleNumber: '',
          rcFile: null,
          vendorPhoto:  null,
        });
      }

    } catch (error) {
      toast.error("Error submitting the form.");
      console.error("Error submitting the form:", error);
    } finally {
      setIsSubmitting(false);  
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full font-poppins">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="col-span-1">
          <label className="block text-gray-600 mb-1">Your Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 border bg-[#F8F8F8] border-[#DDDDDD]"
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="col-span-1">
          <label className="block text-gray-600 mb-1">Mobile Phone</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-3 border bg-[#F8F8F8] border-[#DDDDDD]"
            placeholder="Enter mobile number"
            required
          />
        </div>

        <div className="col-span-1">
          <label className="block text-gray-600 mb-1">Vehicle Number</label>
          <input
            type="text"
            name="vehicleNumber"
            value={formData.vehicleNumber}
            onChange={handleChange}
            className="w-full p-3 border bg-[#F8F8F8] border-[#DDDDDD]"
            placeholder="Enter vehicle number"
            required
          />
        </div>

        <div className="col-span-1">
          <label className="block text-gray-600 mb-1">RC  Upload</label>
          <input
            type="file"
            name="rcFile"
            onChange={handleFileChange}
            className="w-full p-3 border bg-[#F8F8F8] border-[#DDDDDD]"
            required
          />
        </div>

        <div className="col-span-1 md:col-span-2">
          <label className="block text-gray-600 mb-1">Vendor Photo Upload </label>
          <input
            type="file"
            name="vendorPhoto"
            onChange={handleFileChange}
            className="w-full p-3 border bg-[#F8F8F8] border-[#DDDDDD]"
            required
          />
        </div>
      </div>

      <div className="w-full flex items-center justify-center">
        <button
          type="submit"
          className="w-fit mt-6 p-3 bg-[#6b77E5] text-white hover:bg-blue-600"
          disabled={isSubmitting}  // Disable button during submission
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </form>
  );
}

export default InquiryForm;